module.exports = __webpack_public_path__ + "images/emoji/wine_glass.42cfd0e11501e91b02e4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/wine_glass.png
// module id = Q7l5
// module chunks = 2